export default class PeekabooSlider {
    constructor(el) {
        $(document).ready(() => {
            this.$collapseSlider = $(el);

            this.breakpoint =
                typeof this.$collapseSlider.attr('data-breakpoint') !== 'undefined'
                    ? this.$collapseSlider.attr('data-breakpoint')
                    : 640;
            this.breakpointUp = parseInt(this.breakpoint) + 1;
            this.sliderOptions = {
                rows: 0,
                mobileFirst: true,
                autoplay: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                centerMode: true,
                centerPadding: '4%',
                responsive: [
                    {
                        breakpoint: this.breakpointUp,
                        settings: 'unslick',
                    },
                ],
            };

            this.$collapseSlider.slick(this.sliderOptions);
            this.$collapseSlider.find('.grid__item a').attr('tabindex', 0);
            if (this.$collapseSlider.hasClass('slider--filtered')) {
                this.$collapseSlider.slick('slickFilter', '.enable-slide');
            }

            this.initListeners();
        });
    }

    initListeners() {
        $(window).on('resize', () => {
            if ($(window).width() > this.breakpoint) {
                if (this.$collapseSlider.hasClass('slick-initialized')) {
                    if (this.$collapseSlider.hasClass('slider--filtered')) {
                        this.$collapseSlider.slick('slickUnfilter');
                    }

                    this.$collapseSlider.slick('unslick');
                    this.$collapseSlider.find('.grid__item a').attr('tabindex', 0);
                }
            } else if (!this.$collapseSlider.hasClass('slick-initialized')) {
                this.$collapseSlider.slick(this.sliderOptions);

                if (this.$collapseSlider.hasClass('slider--filtered')) {
                    this.$collapseSlider.slick('slickFilter', '.enable-slide');
                }
            }
        });
    }
}
